import { IAuthenticationService, ICredentials } from '../../models/Auth';
import axios from 'axios';
import keycloak from 'utils/keycloak';
import jwt_decode from 'jwt-decode';

let ssoInitialization: Promise<boolean> | undefined;

export default class authServices implements IAuthenticationService {
  auth_url = `${process.env.REACT_APP_PORTAL_API_BASE_URL}/auth`;

  async login(username: string, password: string) {
    const response = await axios.post(`${this.auth_url}/login`, { username, password });
    this.save(response.data);
    return response.data;
  }

  async logout() {
    const refreshToken = this.credentials()?.refresh_token;
    try {
      if (refreshToken) await axios.post(`${this.auth_url}/logout`, { refreshToken });
    } finally {
      this.cleanup();
      if (keycloak.authenticated) {
        await keycloak.logout({ redirectUri: window.location.origin });
      } else {
        window.location.href = '/';
      }
    }
  }

  async refreshToken() {
    try {
      const response = await axios.post(`${this.auth_url}/refresh`, {
        refreshToken: this.credentials()?.refresh_token,
      });
      const credentials = { ...response.data, pipefy_token: this.credentials()?.pipefy_token };
      this.save(credentials);
      if (keycloak.authenticated) {
        keycloak.token = credentials.access_token;
        keycloak.refreshToken = credentials.refresh_token;
        keycloak.tokenParsed = jwt_decode(credentials.access_token);
        keycloak.refreshTokenParsed = jwt_decode(credentials.refresh_token);
      }
      return credentials;
    } catch (error) {
      this.cleanup();
      document.location.href = '/';
      throw error;
    }
  }

  credentials(): ICredentials | undefined {
    const stored = localStorage.getItem('credentials');
    if (!stored) return undefined;
    try {
      return JSON.parse(stored);
    } catch {
      this.cleanup();
      return undefined;
    }
  }

  save(entity: ICredentials) {
    localStorage.setItem('credentials', JSON.stringify(entity));
  }

  cleanup() {
    localStorage.removeItem('credentials');
  }

  checkSSO(): Promise<boolean> {
    if (!ssoInitialization) {
      ssoInitialization = keycloak.init({ onLoad: 'check-sso', checkLoginIframe: false })
        .then(async authenticated => {
          if (!authenticated || !keycloak.token) {
            await keycloak.login();
            return false;
          }
          this.save({
            ...this.credentials(),
            access_token: keycloak.token,
            refresh_token: keycloak.refreshToken,
          } as ICredentials);
          return true;
        })
        .catch(() => false);
    }
    return ssoInitialization;
  }
}
